<script lang="ts" setup>
  import { inject, ref } from 'vue';
  import { useAppStore } from "@/stores/app";
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import cardErrorImage from '@/assets/images/card-error.png';
  import * as amplitude from '@amplitude/analytics-browser';

  const appStore = useAppStore();
  const subscriptionFlowStore = useSubscriptionFlowStore();

  function tryAgain() {
    subscriptionFlowStore.step = 'card';
  }

  const isCardTypeError = ref(subscriptionFlowStore.error.toLowerCase().includes('amex')
    || subscriptionFlowStore.error.toLowerCase().includes('discover'));

  if(isCardTypeError.value) {
    amplitude.track('Payment Failed', {
      "Error Type": subscriptionFlowStore.error,
    });
  }
</script>

<template>
  <div class="content">
    <div class="t-body-1 mt-4">
      <img :src="cardErrorImage" width="50" height="50" alt="">
    </div>
    <div class="t-body-2 mt-4 error-message">
      {{ $t(subscriptionFlowStore.error) }}
    </div>
    <div class="t-body-2 mt-4">
      <span v-if="isCardTypeError">{{ $t('error.card.incorrect_card_type') }}</span>
      <span v-else>{{ $t('error.card.generic') }}</span>
    </div>
    <div class="t-body-2 mt-4">
      <a @click="tryAgain" class="try-again">Try Again</a>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .try-again {
    font-weight: 700;
    color: #0099EB;
  }

  .error-message {
    font-weight: 700;
    font-size: 18px;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    text-align: center;
  }
</style>
